export const getMonthInformation = (
  year: number,
  month: number,
  weekStartsOnSunday: boolean,
) => {
  // Amount of days in the given month
  const amountOfDays = new Date(year, month, 0).getDate();

  // The first and last day (weekday) of the month
  let firstDayOfMonth = new Date(year, month - 1, 1).getDay();
  let lastDayOfMonth = new Date(year, month, 0).getDay();

  // Shift everything 1 spot left and correct for values below 0 (cyclic 0-6, thus 7 = 0)
  if (!weekStartsOnSunday) {
    firstDayOfMonth = firstDayOfMonth - 1;
    lastDayOfMonth = lastDayOfMonth - 1;
    if (firstDayOfMonth < 0) {
      firstDayOfMonth = 6;
    }

    if (lastDayOfMonth < 0) {
      lastDayOfMonth = 6;
    }
  }

  return {
    amountOfDays,
    firstDayOfMonth,
    lastDayOfMonth,
  };
};

export function buildMonthWeeks(amountOfDays, firstDayOfMonth, lastDayOfMonth) {
  const weeks: number[][] = [];

  let weekNumber = 0;

  // Pre-fill first week with 0 values
  weeks[weekNumber] = Array(7).fill(0, 0, firstDayOfMonth + 1);

  // Fill weeks
  let dayWeekNumber = firstDayOfMonth;
  Array(amountOfDays)
    .fill(0)
    .forEach((element, index) => {
      if (!weeks[weekNumber]) {
        weeks[weekNumber] = Array(7);
      }
      weeks[weekNumber][dayWeekNumber] = index + 1;
      dayWeekNumber += 1;
      if (dayWeekNumber === 7) {
        // day ranges from 0 - 6
        dayWeekNumber = 0;
        weekNumber += 1;
      }
    });

  // Post-fill last week with 0 values
  if (lastDayOfMonth !== 6) {
    weeks[weekNumber] = weeks[weekNumber].fill(0, lastDayOfMonth + 1);
  }

  return weeks;
}

export function generateMonth(
  year: number,
  month: number,
  weekStartsOnSunday: boolean,
) {
  const { amountOfDays, firstDayOfMonth, lastDayOfMonth } = getMonthInformation(
    year,
    month,
    weekStartsOnSunday,
  );

  return buildMonthWeeks(amountOfDays, firstDayOfMonth, lastDayOfMonth);
}

export function generateYear(year: number, weekStartsOnSunday: boolean) {
  return Array(12)
    .fill([])
    .map((monthValues, index) => {
      return generateMonth(year, index + 1, weekStartsOnSunday);
    });
}
